import { render, staticRenderFns } from "./NetlifyIdentityUserTable.vue?vue&type=template&id=4127f8c8&"
import script from "./NetlifyIdentityUserTable.vue?vue&type=script&lang=js&"
export * from "./NetlifyIdentityUserTable.vue?vue&type=script&lang=js&"
import style0 from "./NetlifyIdentityUserTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports